import { makeStyles } from 'tss-react/mui'


const useStyles = makeStyles()((theme) => ({
    table: {
        tableLayout: 'fixed',
        '& td': {
            borderBottom: `1px solid ${theme.palette.divider}`,
            borderRight:  `1px solid ${theme.palette.divider}`
        },
        '& td:last-child': {
            borderRight: 'none !important'
        },
        '& .single-view-actions': {
            left: 'calc(var(--strike-column-width, 120px) + 100px) !important',
            right: 'auto !important',
        },
        '& .normal-view-actions': {
            left: 'auto !important', 
            right: '4px !important',
        },
        '& tr:hover .single-view-actions': {
            left: 'calc(var(--strike-column-width, 120px) + 100px) !important',
            right: 'auto !important',
        },
        '& tr:hover .normal-view-actions': {
            left: 'auto !important',
            right: '4px !important',
        }
    },
    container: {
        borderRadius: 0
    },
    tableCell: {
        padding: 0
    },
    hideRow: {
        display: 'none'
    }
}))

export default useStyles